import { render } from "./MessageJamye.vue?vue&type=template&id=6832b634"
import script from "./MessageJamye.vue?vue&type=script&lang=js"
export * from "./MessageJamye.vue?vue&type=script&lang=js"

import "./MessageJamye.vue?vue&type=style&index=0&id=6832b634&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__